import React from "react";

import BuilderWizardStepTwo from "../../components/BuilderWizardStepTwo";

export default ({ register, exercise }) => {
  return <BuilderWizardStepTwo register={register} exercise={exercise} />;
};
